import React, { useEffect, useState } from "react";
import { t } from "../../../../utils/translate";
import { getAfterControlFormByIdService } from "../../../../Services/afterControlFormService";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";
import { GoSearch } from "react-icons/go";
import { IoFilter } from "react-icons/io5";
import { FiEye } from "react-icons/fi";
import { BsClipboardCheck } from "react-icons/bs";
import MainLayout from "../../../components/layout/MainLayout";
import ModalVisual from "../../../../components/forms/ModelVisual";
import Modal from "../../../../components/forms/Modal";

const ViewAfterControlForm = () => {
  const { afterControlId, projectId } = useParams();
  const [signatureImage, setSignatureImage] = useState(null);
  const [signatureImageone, setSignatureImageone] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [approverName, setApproverName] = useState("");
  const { roleOfUser } = useSelector((state) => state?.project);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState("");
  const [showModalVisual, setShowModalVisual] = useState(false);
  const [recentViewVisual, setRecentViewVisual] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [afterControl, setAfterControl] = useState([]);
  const [controlName, setControlName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [filteredAfterControl, setFilteredAfterControl] = useState([]);

  // Fetch data only once when component mounts
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await getAfterControlFormByIdService(afterControlId);
        const responseData = res?.data;
        const filteredData = responseData?.afterControl;

        setControlName(responseData?.controlName);
        setSignatureImage(responseData?.signature?.customer?.signature);
        setCustomerName(responseData?.signature?.customer?.name);
        setSignatureImageone(responseData?.signature?.approver?.signature);
        setApproverName(responseData?.signature?.approver?.name);
        setAfterControl(filteredData);
        setFilteredAfterControl(filteredData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [afterControlId]);

  // Count active, inactive, and disassembled scaffolds
  const counts = afterControl?.reduce(
    (acc, entry) => {
      if (entry.status === "active") acc.active++;
      else if (entry.status === "inactive") acc.inactive++;
      else if (entry.status === "disassembled") acc.disassembled++;
      return acc;
    },
    { active: 0, inactive: 0, disassembled: 0 }
  );

  const getTheNumberOfInspectionDetails = (data) => {
    const counts = {
      yes: 0,
      no: 0,
      na: 0,
      null: 0,
      totalInspection: data?.length || 0,
    };

    data?.forEach((item) => {
      if (item.inspection === "yes") {
        counts.yes += 1;
      } else if (item.inspection === "no") {
        counts.no += 1;
      } else if (item.inspection === "NA") {
        counts.na += 1;
      } else {
        counts.null += 1;
      }
    });

    return counts;
  };

  // Handle search with debounce
  useEffect(() => {
    let debounceTimer;

    if (searchTerm.trim() === "") {
      setFilteredAfterControl(afterControl);
      setSearchLoading(false);
      return;
    }

    setSearchLoading(true);

    debounceTimer = setTimeout(() => {
      const results = afterControl.filter((control) => {
        const term = searchTerm.toLowerCase();

        const scaffoldNames = control?.scaffoldName
          ?.map((el) => `${el?.value}-${el?.key}`)
          ?.join(", ");

        return (
          control?.location?.toLowerCase()?.includes(term) ||
          control.scaffoldIdentificationNumber?.toLowerCase()?.includes(term) ||
          scaffoldNames?.toLowerCase()?.includes(term)
        );
      });

      setFilteredAfterControl(results);
      setSearchLoading(false);
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [searchTerm, afterControl]);

  const handelImage = (scaffold) => {
    setModalImageUrl(scaffold);
    setShowModal(true);
  };

  const handelImage1 = (index, visual) => {
    setRecentViewVisual(visual);
    setCurrentIndex(index);
    setShowModalVisual(true);
  };

  return (
    <MainLayout title={"View After Control Form"}>
      {/* Modals */}
      {showModal && (
        <Modal setShowModal={setShowModal} modalImageUrl={modalImageUrl} />
      )}
      {showModalVisual && (
        <ModalVisual
          roleOfUser={roleOfUser}
          setShowModalVisual={setShowModalVisual}
          visualData={recentViewVisual}
          afterControl={afterControl}
          setAfterControl={setAfterControl}
          currentIndex={currentIndex}
          viewOnly={true}
        />
      )}

      {/* Main content container with shadow */}
      <div className="custom-container bg-white shadow-md rounded-lg p-6 my-8">
        {/* Control Name/Number section */}
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <BsClipboardCheck className="text-blue-600" size={24} />
            <h2 className="text-xl font-bold text-gray-800">
              {t("Control Information")}
            </h2>
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold text-gray-600 mb-1">
              {t("Control Name/Number")}:
            </label>
            {loading ? (
              <div className="h-8 bg-gray-200 animate-pulse rounded w-1/4"></div>
            ) : (
              <div className="border border-gray-300 px-4 py-2 rounded font-bold text-gray-700 bg-gray-50 max-w-xs">
                {controlName || t("Not Assigned")}
              </div>
            )}
          </div>
        </div>

        {/* Search bar */}
        <div className="relative w-full mb-6">
          <div className="relative">
            <GoSearch
              className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500"
              size={20}
            />
            <input
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full border border-gray-300 rounded-md pl-10 pr-12 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              placeholder={t("Search control inspection")}
              type="text"
            />
            <IoFilter
              className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500"
              size={20}
            />
          </div>
        </div>

        {/* Table header */}
        <div className="bg-blue-600 text-white p-3 rounded-t-lg mb-0">
          <h3 className="font-bold">{t("Active scaffolds")}</h3>
        </div>

        {/* Table container with responsive design */}
        <div className="overflow-x-auto border border-gray-200 rounded-b-lg mb-8">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("ScaffoldName/type")}
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("ScaffoldID/Number")}
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("Specificlocation")}
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("Control")}
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("LastInspection")}
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("Comments")}
                </th>
              </tr>
            </thead>

            <tbody className="bg-white divide-y divide-gray-200">
              {searchLoading || loading ? (
                <tr>
                  <td colSpan="6" className="text-center py-10">
                    <div className="flex justify-center items-center">
                      <div className="w-8 h-8 border-t-2 border-b-2 border-blue-500 rounded-full animate-spin"></div>
                    </div>
                    <p className="font-medium mt-3 text-gray-600">
                      {t("Loading...")}
                    </p>
                  </td>
                </tr>
              ) : filteredAfterControl?.length > 0 ? (
                filteredAfterControl.map((scaffold, index) => {
                  const scaffoldNames = scaffold?.scaffoldName
                    ?.map((el) => `${el?.value}-${el?.key}`)
                    ?.join(", ");

                  const inspectionCounts = getTheNumberOfInspectionDetails(
                    scaffold?.visual
                  );

                  return (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">
                        {scaffoldNames}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {scaffold?.scaffoldIdentificationNumber}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <button
                          onClick={() =>
                            handelImage(scaffold?.approvalFormImage)
                          }
                          className="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
                        >
                          <FiEye className="mr-1" />
                          {scaffold?.location}
                        </button>
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <button
                          onClick={() => handelImage1(index, scaffold?.visual)}
                          className={`inline-flex items-center justify-center px-3 py-1.5 rounded text-white font-medium ${
                            inspectionCounts.no > 0
                              ? "bg-red-500 hover:bg-red-600"
                              : inspectionCounts.totalInspection ===
                                inspectionCounts.yes + inspectionCounts.na
                              ? "bg-green-500 hover:bg-green-600"
                              : "bg-blue-500 hover:bg-blue-600"
                          } transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${
                            inspectionCounts.no > 0
                              ? "red"
                              : inspectionCounts.totalInspection ===
                                inspectionCounts.yes + inspectionCounts.na
                              ? "green"
                              : "blue"
                          }-400`}
                        >
                          <FiEye className="mr-1" size={14} />
                          {t("Visual Inspection")}
                        </button>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {new Date(scaffold?.date).toLocaleDateString()}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <div className="max-w-xs max-h-24 overflow-auto p-2 bg-gray-50 rounded border border-gray-200">
                          {scaffold?.afterControlComment || t("No comments")}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="px-4 py-8 text-center text-sm text-gray-500"
                  >
                    {t("No data found")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Form data section */}
        <div className="mb-10">
          <div className="mb-6">
            <h2 className="text-xl font-bold text-gray-800 border-b pb-2">
              {t("formDatas")}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 text-center">
              <h3 className="text-xl font-semibold text-blue-600 mb-4">
                {t("Active-scaffolds")}
              </h3>
              <p className="text-3xl font-bold text-gray-700">
                {counts.active || 0}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 text-center">
              <h3 className="text-xl font-semibold text-orange-500 mb-4">
                {t("Inactive-scaffolds")}
              </h3>
              <p className="text-3xl font-bold text-gray-700">
                {counts.inactive || 0}
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 text-center">
              <h3 className="text-xl font-semibold text-red-500 mb-4">
                {t("Disassembled-scaffolds")}
              </h3>
              <p className="text-3xl font-bold text-gray-700">
                {counts.disassembled || 0}
              </p>
            </div>
          </div>
        </div>

        {/* Signatures section */}
        <div className="mt-10">
          <h2 className="text-xl font-bold text-gray-800 border-b pb-2 mb-6">
            {t("signature")}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Customer signature */}
            <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center">
              {signatureImage ? (
                <div className="flex flex-col items-center mb-4">
                  <div className="border border-gray-200 p-2 mb-2 rounded bg-gray-50">
                    <img
                      className="w-48 object-contain"
                      src={signatureImage}
                      alt="Customer Signature"
                    />
                  </div>
                  <p className="text-gray-800 font-semibold">
                    {_.startCase(_.toLower(customerName))}
                  </p>
                </div>
              ) : (
                <div className="text-center text-gray-500 mb-4 p-6 border border-dashed border-gray-300 rounded-lg w-48">
                  {t("No signature available")}
                </div>
              )}
              <div className="w-full border-t border-gray-200 my-4"></div>
              <p className="text-center text-gray-600">
                {t("customer'sSignature")}
              </p>
            </div>

            {/* Approver signature */}
            <div className="border border-gray-200 rounded-lg p-6 flex flex-col items-center">
              {signatureImageone ? (
                <div className="flex flex-col items-center mb-4">
                  <div className="border border-gray-200 p-2 mb-2 rounded bg-gray-50">
                    <img
                      className="w-48 object-contain"
                      src={signatureImageone}
                      alt="Approver Signature"
                    />
                  </div>
                  <p className="text-gray-800 font-semibold">
                    {_.startCase(_.toLower(approverName))}
                  </p>
                </div>
              ) : (
                <div className="text-center text-gray-500 mb-4 p-6 border border-dashed border-gray-300 rounded-lg w-48">
                  {t("No signature available")}
                </div>
              )}
              <div className="w-full border-t border-gray-200 my-4"></div>
              <p className="text-center text-gray-600">
                {t("signatureOfTheApprover")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewAfterControlForm;
